import React, { useContext, useMemo } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { FeatureFlags, Me, TabParamsType } from '@chiroup/core';
import { MeContext } from '../../contexts/me.context';
import IntegrationMain from './IntegrationMain';
import Integration837p from './Integration837p';

const BASE_PATH = '/integration';
const FEATURE_TITLE = 'Integrations';
const TABS: { [key: string]: TabParamsType } = {};
const TAB_TITLE_CLASS_NAME =
  'mt-2 border border-gray-400 bg-gray-50 flex justify-center px-2 py-1 rounded-lg text-sm font-bold w-min';
const TAB_CONTAINER_CLASS_NAME = 'flex justify-start p-4';

export type TabComponentParams = {
  me: Me;
  tabs: TabParamsType[];
  tab: TabParamsType;
  featureTitle: string;
  tabTitleClassName?: string;
  tabContainerClassName?: string;
};

const IntegrationRoutes: React.FC = () => {
  const { me, hasAccess } = useContext(MeContext);
  const { pathname } = useLocation();
  const tabs = useMemo(() => {
    const theTabs = [];
    if (hasAccess(FeatureFlags.ehr)) {
      /**
       * There is no "intro" page, so we make the first tab active.
       */
      let routePath = `/main`,
        fqPath = [BASE_PATH, routePath].join('');

      TABS.main = {
        name: 'Main',
        href: fqPath,
        active: pathname === fqPath,
        routePath: routePath,
      };
      theTabs.push(TABS.main);
      routePath = `/837p`;
      fqPath = [BASE_PATH, routePath].join('');

      TABS._837p = {
        name: '837P',
        href: fqPath,
        active: pathname === fqPath,
        routePath: routePath,
      };
      theTabs.push(TABS._837p);
    }
    return theTabs;
  }, [pathname, hasAccess]);

  if (!hasAccess(FeatureFlags.ehr)) return null;

  console.log({ IntegrationRoutes: { tabs, TABS_BY_NAME: TABS } });

  return (
    <Routes>
      <Route path="/" element={<Navigate to={TABS.main.href} replace />} />
      <Route
        path={`${TABS.main.routePath}`}
        element={
          <IntegrationMain
            me={me}
            tabs={tabs}
            tab={TABS.main}
            featureTitle={FEATURE_TITLE}
            tabTitleClassName={TAB_TITLE_CLASS_NAME}
            tabContainerClassName={TAB_CONTAINER_CLASS_NAME}
          />
        }
      />
      <Route
        path={`${TABS._837p.routePath}`}
        element={
          <Integration837p
            me={me}
            tabs={tabs}
            tab={TABS._837p}
            featureTitle={FEATURE_TITLE}
            tabTitleClassName={TAB_TITLE_CLASS_NAME}
            tabContainerClassName={TAB_CONTAINER_CLASS_NAME}
          />
        }
      />
    </Routes>
  );
};

export default IntegrationRoutes;
